import styled from 'styled-components';

interface SelectedProps {
  selected?: boolean;
}

export const TimeSlotMessage = styled.div`
  font-size: 14px;
  margin-top: 4px;
  padding: 12px 16px;
  color: ${({ theme }) => theme.colors.neutral.primaryNavy};
  border: 2px dashed ${({ theme }) => theme.colors.neutral.lavender};
  border-radius: 8px;
  text-align: center;
`;

export const BookingTimeContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 20px;
`;

export const TimeOfDayText = styled.div`
  font-size: 18px;
  color: ${({ theme }) => theme.colors.neutral.primaryNavy};
  padding-bottom: 10px;
  font-weight: bolder;
`;

export const DayContainer = styled.div`
  padding-bottom: 20px;
`;

export const TimeSlotContainer = styled.div.attrs<{ 'data-testid'?: string }>({
  'data-testid': 'time-slot-container'
})`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const TimeSlotBubble = styled.button.attrs({ type: 'button' })<SelectedProps>`
  cursor: pointer;
  width: 80px;
  height: 28px;
  border-radius: 14px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
  margin-right: 4px;
  margin-bottom: 4px;
  position: relative;
  background-color: white;

  ${({ theme, selected }) => `
    border: ${selected ? `2px solid ${theme.colors.yellow.darkYellow}` : `1px solid ${theme.colors.neutral.lavender}`};
  `}

  &:hover {
    border: solid 2px ${({ theme }) => theme.colors.neutral.primaryNavy};
  }
  transition: all 400ms ease 0s;
`;

export const TimeSlotText = styled.div<SelectedProps>`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutral.primaryNavy};
  font-weight: ${({ selected }) => (selected ? '600' : '400')};
  transition: all 400ms ease 0s;
`;

export const CameraIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;

  position: absolute;
  top: -12px;
  right: -10px;

  background-color: ${({ theme }) => theme.colors.yellow.darkYellow};
  border-radius: 100px;
`;
